import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'


const Id2 = () => {

    const detail = 
        {
            id:2,
            imgSrc:cover,
            ini:'Exhibition: discover the mystery of Lao bats at the Institut français in Luang Prabang',
            href:'',
            element:'',
            topic:'',
            inform:`Produced by IRD (LMI PRESTO), the exhibition ‘Bat Biodiversity: A Photographic Journey to the Heart of Laos’ at the Institut français (IF) in Luang Prabang features photographs by Arisa Chandarak and Nicola Gasperini, shot as part of a study into the diversity and geographical distribution of bats in Vientiane province.
            <br><b>Around fifty people gathered at the IF in Luang Prabang (northern Laos) on February 19, to celebrate the opening of the exhibition.</b> Among them: the Cooperation and Cultural Action Advisor and Director of the IF in Laos, Ms Nathalie Brat, the Director of the IF in Luang Prabang, Ms Elodie Laure, local personalities and pupils from the Luang Prabang primary school.
            <br><b>On display until April 30, 2025, ‘Bat Biodiversity: A Photographic Journey to the Heart of Laos’ is an artistic project linking art and science.</b> Produced as part of a scientific study on bats as natural reservoirs of coronavirus led by Arisa Chandarak, Nicola Gasperini and Sabrina Locatelli between 2022 and 2024, this exhibition focuses on the diversity and geographical distribution of these mammals in Vientiane province. Beyond their importance for medical research, these fascinating animals play a crucial role as forest pollinators and natural predators of mosquitoes that carry diseases such as dengue fever, helping to keep the balance of ecosystems in balance.
            <br><b>The exhibition features 26 photos and a short film on some of the study sites.</b> Posters and educational games explaining the essential role of bats in ecosystem preservation, their movement by echolocation and other information suitable for younger visitors are also available at the end of the exhibition. 
            `
        ,
            link1:`https://en.ird.fr/exhibition-discover-mystery-lao-bats-institut-francais-luang-prabang`
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
